<div class="ranking-row" [class]="{ 'alternate': row.position % 2 == 0 }">
	<div class="ranking-name flex justify-content-between" (click)="toggleDeaths()">
		<span class="position">{{ row.position }}.</span>
		<div class="better flex-grow-1">
			<span class="name">{{ row.name | titlecase }}</span>
			<span class="location">{{ row.location }}</span>
		</div>
		<span class="points">{{ row.points }} pontos</span>
	</div>
	<div class="ranking-deaths" *ngIf="showDeaths">
		<div class="bet" *ngFor="let d of row.deaths" (click)="goToDeadView(d.id, d.name)">
			<span class="dead-points">{{ d.points }} pontos</span>
			<span class="dead-name">{{ d.name }}</span>
		</div>
	</div>
</div>
